import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { publicPaymentsApi } from 'src/app/services/constants/api.constants';
import { HelpersService, HttpBaseService } from '@evento-ng/libs';
import { ApprovalStatusEnum } from 'src/app/services/enums/approval-status.enum';

@Component({
  selector: 'app-validate',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.scss'],
})
export class ValidateComponent implements OnInit, OnDestroy {
  invoiceId!: string;
  isValid!: any;
  tickets: any;
  subs: Subscription[] = [];
  ApprovalStatusEnum = ApprovalStatusEnum;
  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    public helpers: HelpersService,
    public translate: TranslateService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.isValid = null;
    this.validate();
  }

  validate() {
    this.route.params.subscribe((params) => {
      this.invoiceId = params['id'];
      this.spinner.show();
      this.dataService
        .get(`${publicPaymentsApi}/${this.invoiceId}/validate`)
        .subscribe(
          (res) => {
            if (res?.invoice) {
              this.tickets = res.invoice;
              if (res.invoice.status === 'PAID') {
                this.isValid = true;
              } else {
                this.isValid = false;
              }
            } else {
              this.validate();
            }
            this.spinner.hide();
          },
          (err) => {
            console.error(err);
            this.spinner.hide();
          }
        );
    });
  }

  downloadInvoice(): void {
    window.open(window.origin + '/html-design/' + this.invoiceId, '_blank');
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  goBack() {
    this.router.navigateByUrl('/event-details/' + this.tickets?.event?.id);
  }
}
